import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Subscription } from 'rxjs';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { Permission } from 'src/app/models/principal/permission';
import { RouterSegments } from 'src/app/models/router-segments';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DateTimeFormatService } from 'src/app/services/util/date-time-format.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { ToastrErrorService } from 'src/app/services/util/toastr-error.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ColumnFilterComponent } from '../../instances-mgmt/column-filter/column-filter.component';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { Constants } from 'src/app/models/constants';
import { AddCustomImageComponent } from '../add-custom-image.component/add-custom-image.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { ComponentsService } from 'src/app/services/api/components.service';
import { JsonValidationService } from 'src/app/services/util/json-validation.service';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { customImagesSchema } from 'src/app/schemas/customImages-schema';

@Component({
  selector: 'app-create-custom-image.component',
  templateUrl: './create-custom-image.component.html',
  styleUrl: './create-custom-image.component.scss',
  standalone: false
})
export class CreateCustomImageComponent  implements OnInit {
  private destroyRef = inject(DestroyRef);

  RouterSegments = RouterSegments;
  solutions: any[];
  tenant: string;
  dropdownsList: any = [];
  selectedLineOfBusiness: any;
  selectedCategory: any;
  selectedRegion: any;
  selectedTenant: any;
  showSpinner = false;
  solutionsPage: any[];
  defaultSolutions: any;
  searchText: string;
  paginationSize = 10;
  pageIndex = 0;
  viewSelected = 'grid';
  filteredColumns: any;
  subscription: Subscription;
  breadcrumbItems: BreadcrumbItem[] = [];
  isReader: boolean;
  Permission = Permission;
  isFailed = false;
  categoryList: any;
  regionList: any;
  tenantList: any;
  tenantId: string;
  isSolutionSelected = false;
  selectedSolution: any;
  Constants = Constants;
  jsonInput = '';
  selectedTab = 0;
  selectedComponent: any;
  customImageName: any;
  formData = [];
  customImageForm: FormGroup;
  disableSubmit = true;
  components: any;
  resetJSONEditor: boolean;
  validJson: boolean;
  editorOptions = {
    theme: 'light',
    language: 'json',
    automaticLayout: true,
  };
  isLoading = false;
  existingCustomImageNames: string[] = [];
  componentsLoading = false;
  constructor(private solutionsService: SolutionsService, public authService: AuthService, private sidenavService: SidenavService,
    private toastrService: ToastrService, public customToastrService : CustomToastrService, public dateTimeFormatService: DateTimeFormatService, private tenantService: TenantService,
    private permissionsService: PermissionsService, private dialog: MatDialog, private toastrErrorService: ToastrErrorService,
    private activatedRoute: ActivatedRoute, private router: Router, private formBuilder: FormBuilder, private componentService: ComponentsService,
    private schemaValidator: JsonValidationService) {

   }

  ngOnInit(): void {
    this.sidenavService.tenantSelectedMenu = 'TENANT_LAYOUT.MENU.CUSTOM_IMAGE';
    this.tenantId = this.activatedRoute.snapshot.params.id;
    this.tenant = this.authService.principal.provider;
    this.breadcrumbItems.push({icon: 'assets/images/home_icon.svg'},
      {label: translate('TENANT_LAYOUT.MENU.CUSTOM_IMAGE'), url:[RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE]},
      {label: translate('LEFT_SIDE_NAV.SOLUTIONS'), click: ['solutions']});

    const categoryOptions = [
      {value: 'SaaS' , selected: false},
      {value: 'BSG' , selected: false},
      {value: 'Demo' , selected: false},
      {value: 'Hosted' , selected: false},
    ];
    const regionOptions = [
      {value: 'APAC' , selected: false},
      {value: 'APAC_2' , selected: false},
      {value: 'AUSTRALIA' , selected: false},
      {value: 'AUSTRALIA_2' , selected: false},
      {value: 'BRAZIL' , selected: false},
      {value: 'BRAZIL_2' , selected: false},
      {value: 'CANADA' , selected: false},
      {value: 'EUROPE' , selected: false},
      {value: 'FRANCE' , selected: false},
      {value: 'GERMANY' , selected: false},
      {value: 'INDIA' , selected: false},
      {value: 'JAPAN' , selected: false},
      {value: 'KOREA' , selected: false},
      {value: 'NORWAY' , selected: false},
      {value: 'SOUTH_AFRICA' , selected: false},
      {value: 'SWEDEN' , selected: false},
      {value: 'SWITZERLAND' , selected: false},
      {value: 'UK' , selected: false},
      {value: 'NORTH_AMERICA' , selected: false},
      {value: 'NORTH_AMERICA_2' , selected: false},
      {value: 'NORTH_AMERICA_3' , selected: false},
      {value: 'NORTH_AMERICA_4' , selected: false},
      {value: 'UAE' , selected: false}
    ];
    this.dropdownsList = [
      {
        title: 'Line Of Business',
        placeholder: 'Select Line Of Business',
      },
      {
        title: 'Category',
        placeholder: 'Select Category',
        options: []
      },
      {
        title: 'Region',
        placeholder: 'Select Region',
        options: []
      },
      {
        title: 'Tenant',
        placeholder: 'Select Tenant',
        options: []
      }
    ];

    const lineOfBusiness = localStorage.getItem('tenantSerDefLineOfBusiness');
    if (lineOfBusiness) {
      this.selectedLineOfBusiness = lineOfBusiness;
    }
    const category = localStorage.getItem('customPackCategory');
    if (category) {
      this.selectedCategory = category;
    }
    const region = localStorage.getItem('customPackRegion');
    if (region) {
      this.selectedRegion = region;
    }
    this.categoryList = [...new Set(categoryOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.categoryList.forEach((value) => {
      this.dropdownsList[1].options.push({value, selected: false});
    });
    this.regionList = [...new Set(regionOptions.map(item => item.value).sort((a, b) => (a.toLowerCase() < b.toLowerCase()) ? -1 : 1))];
    this.regionList.forEach((value) => {
      this.dropdownsList[2].options.push({value, selected: false});
    });
    const tenant = localStorage.getItem('customPackTenant');
    if (tenant) {
      this.selectedTenant = tenant;
    }
    this.getTenants();

    this.loadSolutions(this.selectedLineOfBusiness,
      this.selectedCategory, this.selectedRegion, this.selectedTenant);
      localStorage.removeItem('selectedVersion');
      localStorage.removeItem('selectedVersionExtend');
      this.buildCustomImageForm();
  }

  // to load tenants
  getTenants(): void {
    this.dropdownsList[3].options = [];
    this.tenantService.getTenants()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          this.tenantList = [...new Set(data.map(item => item.tenantId))];
          this.tenantList.forEach((value) => {
          this.dropdownsList[3].options.push({value, selected: false});
        });
        }
      });
  }

  // to load solutions
  loadSolutions(lineOfBusiness?, category?, regionalAvailability?, selectedTenant?): void {
    this.pageIndex = 0;
    this.showSpinner = true;
    this.isFailed = false;
    this.solutions = [];
    if (lineOfBusiness) {
      localStorage.setItem('tenantSerDefLineOfBusiness', lineOfBusiness);
    } else {
      localStorage.removeItem('tenantSerDefLineOfBusiness');
    }
    if (category) {
      localStorage.setItem('customPackCategory', category);
    } else {
      localStorage.removeItem('customPackCategory');
    }
    if (regionalAvailability) {
      localStorage.setItem('customPackRegion', regionalAvailability);
    } else {
      localStorage.removeItem('customPackRegion');
    }
    if (selectedTenant) {
      localStorage.setItem('customPackTenant', selectedTenant);
    } else {
      localStorage.removeItem('customPackTenant');
    }
    const solutionObj = {
      lineOfBusiness,
      category,
      regionalAvailability
    };
    this.solutionsService.getSolutions(solutionObj)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        if (data) {
          data = data.sort((a,b) => b?.dateCreated?.localeCompare(a?.dateCreated));
          let filterData = data;
          if (selectedTenant) {
            filterData = data.filter(item=> item.tenantId === selectedTenant);
          }
          this.solutions = filterData;;
          let solutionLob = '';
          if (localStorage.getItem('customPackSolutionLob')) {
            solutionLob = JSON.parse(localStorage.getItem('customPackSolutionLob'));
          }
          this.defaultSolutions = filterData;
          this.searchSolution();
          if (!this.dropdownsList[0].options) {
            let options = [];

            if (!solutionLob) {
              this.solutions.forEach(solution => {
                if (!options.find(item => item.value === solution.lineOfBusiness[0])) {
                  const obj = {
                    value: solution.lineOfBusiness[0],
                    selected: false
                  };
                  options = [...options, obj];
                }
              });
              this.dropdownsList[0].options = options;
              localStorage.setItem('customPackSolutionLob', JSON.stringify(this.dropdownsList[0].options));
            } else {
              const defaultLob = JSON.parse(localStorage.getItem('customPackSolutionLob'));
              this.dropdownsList[0].options = defaultLob;
            }
          }
          this.showSpinner = false;
        }
      },
      (error) => {
        this.showSpinner = false;
        this.isFailed = true;
        setTimeout(() => {
      const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.customToastrService.errMessage(message, title);
        }, 500);
      });
  }

  // to filter the records based on filter options selected
  filterColumns(): void {
    if (this.selectedLineOfBusiness) {
      this.dropdownsList[0].options.filter((item) => {
        if (item.value === this.selectedLineOfBusiness) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[0].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedCategory) {
      this.dropdownsList[1].options.filter((item) => {
        if (item.value === this.selectedCategory) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[1].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedRegion) {
      this.dropdownsList[2].options.filter((item) => {
        if (item.value === this.selectedRegion) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[2].options.filter((item) => {
        item.selected = false;
      });
    }
    if (this.selectedTenant) {
      this.dropdownsList[3].options.filter((item) => {
        if (item.value === this.selectedTenant) {
          item.selected = true;
        }
      });
    } else {
      this.dropdownsList[3].options.filter((item) => {
        item.selected = false;
      });
    }
    const data = {
      name: translate('INSTANCE_STATUS.SOLUTION'),
      title: translate('INSTANCE_STATUS.FILTER_TITLE'),
      subtitle: translate('INSTANCE_STATUS.FILTER_SUBTITLE'),
      filteredColumns: this.dropdownsList,
      lineOfBusiness: this.dropdownsList[0].options,
      category: this.dropdownsList[1].options,
      region: this.dropdownsList[2].options,
      tenant: this.dropdownsList[3].options,
      page: 'tenantSolutions'
    };
    this.sidenavService.openInRightSidenav(ColumnFilterComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filteredColumns => {
        if (filteredColumns) {
          this.filteredColumns = filteredColumns;
          if(filteredColumns[0] !== ''){
            this.selectedLineOfBusiness = filteredColumns[0];
          }
          if(filteredColumns[1] !== ''){
            this.selectedCategory = filteredColumns[1];
          }
          if(filteredColumns[2] !== ''){
            this.selectedRegion = filteredColumns[2];
          }
          if(filteredColumns[3] !== ''){
            this.selectedTenant = filteredColumns[3][0];
          }
          this.loadSolutions(this.selectedLineOfBusiness,
            this.selectedCategory, this.selectedRegion, this.selectedTenant);
        }
      });
  }

  // custom validator to block duplicate custom image name
  private duplicateNameValidator = (control: any): { duplicateName: boolean } | null => {
    const value = control.value?.trim().toLowerCase();
    if (!value) {
      return null;
    }
    const isDuplicate = this.existingCustomImageNames.some(
      name => name?.trim().toLowerCase() === value
    );
    return isDuplicate ? { duplicateName: true } : null;
  };

  // builds the custom image form with required, minLength, and duplicate-name validators
  private buildCustomImageForm(): void {
    const formConfig: any = {
      customImageName: [
        undefined,
        [Validators.required, Validators.minLength(5), this.duplicateNameValidator]
      ],
    };
    this.customImageForm = this.formBuilder.group(formConfig);
  }

  //get existing custom image names
  private getExistingCustomImageNames(): void {
    this.solutionsService.getReferencePackages(this.selectedSolution.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((response: any) => {
        this.existingCustomImageNames = response?.data?.map((img: any) => img.name) ?? [];
        this.customImageForm.get('customImageName')?.updateValueAndValidity();
      });
  }

  // to update records when page number is changed
  pageChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.paginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.paginationSize;
      this.solutionsPage = this.solutions.slice(firstIndex, firstIndex + this.paginationSize);
    }
  }

  // to reset the table when filter is resetted
  resetFilter(): void {
    this.selectedLineOfBusiness = undefined;
    this.selectedCategory = undefined;
    this.selectedRegion = undefined;
    this.selectedTenant = undefined;
    this.sidenavService.searchFilter.next('data');
    this.resetAllValues();
    this.loadSolutions();
  }

  // to remove a particular filter using cross icon
  resetValue(closedItem): void {
    closedItem?.options?.forEach(element => {
      element.selected = false;
    });
  }

  // resetting filter options when filter is removed
  resetAllValues(): void {
    this.dropdownsList.forEach(element => {
     element?.options?.forEach(item => {
       item.selected = false;
     });
   });
   localStorage.removeItem('customPackSolutionLob');
  }

  // calling filter column functions when cross icon is clicked in filter option
  closeMenu(data): void {
    this.sidenavService.searchFilter.next(data);
    this.filteredColumnsFunction(data);
  }

  // to update filter according to latest selection
  filteredColumnsFunction(data): void {
    if(this.selectedLineOfBusiness === data) {
      this.selectedLineOfBusiness = undefined;
      this.resetValue(this.dropdownsList[0]);
    }else if(this.selectedCategory === data) {
      this.selectedCategory = undefined;
      this.resetValue(this.dropdownsList[1]);
    } else if(this.selectedRegion === data) {
      this.selectedRegion = undefined;
      this.resetValue(this.dropdownsList[2]);
    } else if(this.selectedTenant === data) {
      this.selectedTenant = undefined;
      this.resetValue(this.dropdownsList[3]);
    }
    this.loadSolutions(this.selectedLineOfBusiness,
      this.selectedCategory, this.selectedRegion, this.selectedTenant);
  }

  // to search solution using search box
  searchSolution(event?): void {
    if (event) {
      this.searchText = event.target.value;
    } else if (this.searchText) {
      this.searchText = this.searchText;
    }

    this.solutions = this.defaultSolutions;
    if (this.searchText) {
      this.solutions = this.solutions?.filter(item => item.name.toLocaleLowerCase().includes(this.searchText.toLocaleLowerCase()));
    } else {
      this.solutions = this.defaultSolutions;
    }
    this.solutionsPage = this.solutions?.slice(this.pageIndex, this.paginationSize);
  }

  // to show the create custom package flow
  createCustomPackage(solution): void {
    this.isSolutionSelected = true;
    this.selectedSolution = solution;
    this.customImageName = undefined;
    this.buildCustomImageForm();
    this.getExistingCustomImageNames();
    this.formData = [];
    this.selectedTab = 0;
    this.componentsLoading = true;
    this.components = undefined;
    this.getComponents();
    this.jsonInput = undefined;
  }

  // to load components
  getComponents(): void {
     this.componentService.getComponents()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        this.components = [];
        data.forEach(item => {
          if (!this.components.find(comp => comp.name === item.name)) {
            this.components = [...this.components, item];
          }
        })
        this.componentsLoading = false;
      },
      (error) => {
        this.componentsLoading = false;
        this.components = null;
      });
  }

  // to navigate back when back icon is clicked
  navigateItem(event): void {
    if (event.label === translate('LEFT_SIDE_NAV.SOLUTIONS')) {
      this.isSolutionSelected = false;
      this.customImageName = undefined;
      this.buildCustomImageForm();
      this.formData = [];
      this.selectedTab = 0;
      this.jsonInput = undefined;
      this.validJson = undefined;
    }
  }

  // assinging json input
  jsonChange(event): void {
    this.jsonInput = event.target.value;
  }

  // switching between json and form view
  tabChange(event): void {
    if (event === 0) {
      this.selectedTab = 0;
        this.validJson = undefined;
        if (this.formData?.length) {
          const jsondata = {
            references: this.formData
          }
          this.jsonInput = JSON.stringify(jsondata, null, 2);
        } else {
          this.jsonInput = undefined;
        }
    } else if (event === 1) {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 10);
      this.selectedTab = 1;
      if (this.jsonInput?.length && this.validateJson() ) {
        const parseJson = JSON.parse(this.jsonInput)
        this.formData = parseJson.references;
        this.validJson = true;
      }
    }
  }

  // assinging custom image name
  onCustomImageName(event): void {
    this.customImageName = event.target.value;
  }


  // showing add component popup when add components is clicked
  addComponent(): void {
    if (this.components) {
      const data = {
        components: this.components,
      }
      this.sidenavService.openInRightSidenav(AddCustomImageComponent, data)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((formData) => {
          if (formData) {
            if (this.formData.find(item => item.component === formData.component)) {
              const index = this.formData.findIndex(item => item.component === formData.component);
              this.formData[index].images = [...this.formData[index].images, ...formData.images];
              this.formData[index].packages = [...this.formData[index].packages, ...formData.packages];
            } else {
              this.formData = [...this.formData, formData];
            }
          }
        });
    }
  }

  // when edit button is clicked passing the component data and calling add component for edit
  editClick(editData): void {
    const data = {
      components: this.components,
      edit: true,
      editData
    }
    this.sidenavService.openInRightSidenav(AddCustomImageComponent, data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((formData) => {
        if (formData) {
          const index = this.formData.findIndex(item => item.component === editData.component);
          this.formData[index] = formData;
        }
      });
  }

  // to delete a component data when delete button is clicked
  deleteClick(data): void {
    const index = this.formData.findIndex(item => item.component === data.component);
    this.formData.splice(index, 1);
  }

  // changing to form view when next button is clicked
  nextClick(): void {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 10);
    this.selectedTab = 1;
    if (this.jsonInput?.length && this.validateJson() ) {
      const parseJson = JSON.parse(this.jsonInput)
      this.formData = parseJson.references;
    }
  }

  // showing confirmation popup and posting the custom image on submit click
  submitClick(): void {
    if (!FormUtilService.validateForm(this.customImageForm)) {
      return;
    }
    let hasError = false;
    this.formData.forEach(item => {
      if (!this.components?.find(data => data.name === item.component)) {
        hasError = true;
      }
    })
    if (hasError) {
      this.dialog.open(ErrorDialogComponent, {
        minHeight: '280px',
        width: '630px',
        panelClass: 'flex-dialog',
        data: {
          title:  translate('ERROR_DIALOG.INVALID_CREATION_OPERATION'),
          description: translate('ERROR_DIALOG.INVALID_CREATION_MESSAGE')
        }
      });
      return;
    }
    const obj = {
      solutionId: this.selectedSolution.id,
      name: this.customImageName,
      tenantId: this.tenantId,
      references: this.formData
    }
    this.dialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title:translate('CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE'),
        message:translate('CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE_MESSAGE'),
        confirmButtonText: translate('DIALOG.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.solutionsService.postSolutionPackageReferences(obj)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
              setTimeout(() => {
                const title = translate('CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE');
                const message = translate('CUSTOM_IMAGES.CREATE_CUSTOM_IMAGE_TRIGGERED');
                this.customToastrService.successMessage(message, title);
              }, 500);
              this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.tenantId, RouterSegments.CUSTOM_IMAGE]);
          }, (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
            this.dialog.open(ErrorDialogComponent, {
              minHeight: '280px',
              width: '630px',
              panelClass: 'flex-dialog',
              data: {
                title:  translate('CUSTOM_IMAGES.CUSTOM_IMAGE_CREATION_FAILED'),
                description: errorMessage
              }
            });
          });
        }
      });
  }

  // Validate json object
  validateJson(): any {
    this.resetJSONEditor = false;
    if (this.jsonInput) {
      try {
        JSON.parse(this.jsonInput);
        this.validJson = this.schemaValidator.validate(JSON.parse(this.jsonInput),customImagesSchema).valid;
      }
      catch  (e) {
        this.validJson = false;
      }
    } else {
      this.validJson = false;
    }
    return this.validJson;
  }

  // Paste copied json object to the json editor
  async pasteJson () {
    const text = await navigator.clipboard.readText();
    this.jsonInput = text;
  }

  // Clear the added json object from json editor
  clearJson () {
    this.jsonInput = undefined;
    this.resetJSONEditor = true;
  }
}
